<template lang="pug">
  .step
    .row.flex(v-for="(spouse, spouse_id) in this.family.spouse" :key="spouse_id + 100")
      .label 配偶者
      .text
        v-text-field(v-model="spouse.comment" placeholder="お名前6文字まで" maxlength="6" @change="change_checkbox")
      .radio
        v-checkbox(label="既に他界" v-model="spouse.exist" @change="change_checkbox")
    .row_child.flex(v-for="(parent, parent_id) in this.family.parent" :key="parent_id")
      .label {{parent.label}}
      .text
        v-text-field(v-model="parent.comment" placeholder="お名前6文字まで" maxlength="6" @change="change_checkbox")
      .radio
        v-checkbox(label="既に他界" v-model="parent.exist" @change="change_checkbox")
      .row_grand_child.flex.grand_child_button(v-if="parent.grand_parent.length == 0")
        button(@click="append_grand_parent(parent_id)" :data-parent-id="parent_id") 祖父母を追加
      .row_grand_child.flex(v-for="(grand_parent, grand_parent_id) in parent.grand_parent" :key="grand_parent_id")
        .label.label_grand_child {{grand_parent.label}}
        .text.text_grand_child
          v-text-field(v-model="grand_parent.comment" placeholder="お名前6文字まで" maxlength="6" @change="change_checkbox")
        .radio
          v-checkbox(label="既に他界" v-model="grand_parent.exist" @change="change_checkbox")
    hr
    .button_area.button_next
      button.blue_button(@click="step02") STEP2：遺産入力へ
      BackButton
    .sp_scroll_navi
      .up(@click="scrollTop")
        .arrow ↑
        .text
          |相続人
          br
          |入力へ
      .down(@click="scrollDown")
        .text
          |相続関係図
          br
          |確認へ
        .arrow ↓
    Popup(frameUrl="https://imasugu-souzoku.com/popup02.html" maxHeight="490px")
</template>

<script lang="js">
import BackButton from '@/components/module/BackButton.vue';
import Popup from '@/components/module/Popup.vue';

export default {
  components: {
    BackButton,
    Popup,
  },
  data: () => ({
    family: {},
  }),
  props: {
    redraw: {
      type: Boolean,
      default: false,
    },
  },

  computed: {

  },
  methods: {
    button_click() {
      this.$router.push('/step01_3');
    },
    change_checkbox(e) {
      this.$emit('change_family', {family: this.family});
    },
    scrollTop() {
      window.scrollTo(0, 0);
    },
    scrollDown() {
      window.scrollTo(0, document.querySelector('#wrapper').offsetTop);
    },
    step02() {
      this.$emit('go_step02', '');
    },
    append_grand_parent(parentID) {
      this.family.parent[parentID].grand_parent = [
        {
          label: '祖父',
          comment: '',
          exist: false,
          delete: false,
        },
        {
          label: '祖母',
          comment: '',
          exist: false,
          delete: false,
        },
      ];
      this.$emit('append_grand_parent', parentID);
    },
  },
  mounted() {
    const json = localStorage.getItem('_isan_data');
    if (json) {
      this.family = JSON.parse(json);
    }
  },
};
</script>

<style lang="sass" scoped>
.flex
  display: flex
  flex-wrap: wrap
  align-items: center
  width: 100%
  margin: 10px 0

  .label
    width: 20%
    box-sizing: border-box
    text-align: center
  .label_grand_child
    width: 30%
  .text
    width: 50%
    input
      width: 100%
      padding: 10px
      box-sizing: border-box
      border: solid 1px $light-gray
  .text_grand_child
    width: 40%
  .radio
    width: 30%
    box-sizing: border-box
    padding: 0 10px
.grand_child_button
  justify-content: flex-end
  margin-right: 28px
  button
    font-size: 18px
    padding: 8px 20px
    background-color: $clear-gray
    border: none
    border-radius: 6px
    transition: 0.6s
    &:hover
      opacity: 0.4
.button_next
  flex-direction: column
  justify-content: center
  align-items: center
  button
    &:nth-child(2)
      margin-top: 20px
      width: 300px
.blue_button
  width: 300px
  height: 60px

.sp_scroll_navi
  display: none
@media screen and (max-width: $break-header)
  .flex
    .label
      width: 100px
      box-sizing: border-box
      text-align: center
    .label_grand_child
      width: 110px
    .text
      width: 33%
      input
        width: 100%
        padding: 10px
        box-sizing: border-box
        border: solid 1px $light-gray
    .text_grand_child
      width: 30%
    .radio
      width: 110px
      box-sizing: border-box
      padding: 0 10px
  .sp_scroll_navi
    //display: block
    display: none
    position: fixed
    right: 0
    bottom: 30px
    .up
      text-align: center
      background-color: $light-gray
      border-top-left-radius: 4px
      padding: 20px
    .down
      text-align: center
      background-color: #808080
      color: $white
      border-bottom-left-radius: 4px
      padding: 20px
  .button_next
    display: none
</style>